// src/stores/ui.js
import { defineStore } from 'pinia'
import { getVocabulario } from '@/composables/useVocabulario'

export const useUiStore = defineStore('vocabulario', {
  state: () => ({
    ui: {}
  }),
  actions: {
    async cargarVocabulario() {
      this.ui = await getVocabulario()      
    },
    limpiar() {
      this.ui = {
        managements:{
          informacionGeneral:{},
          pago:{},
          direccion:{},
          telefonos:{}
        }
      }
    }
  }
})